import React, { useEffect, useState, useContext } from 'react';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';
import AuthContext from '../contexts/AuthContext';
import ModalContext, { ModalProvider } from '../contexts/ModalContext';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const Layout = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAuth, setIsAuth] = useState(!!localStorage.getItem("token"));
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    logout();
    setShowModal(false);
    navigate('/login');
  };

  const checkTokenExpiration = () => {
    const token = localStorage.getItem("token") ;
    if (token) {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setIsAuth(false);
  };

  useEffect(() => {
    checkTokenExpiration();
  }, [location.pathname]);

  return (
    <AuthContext.Provider value={{ isAuth }}>
      <ModalContext.Provider value={{ showModal, handleShow, handleClose }}>
        <Header isAuth={isAuth} handleLogout={logout}/>
        <Outlet/>
        <Footer />
        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>重新登入</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className='text-center my-4'>登入逾時，請重新登入</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              確認
            </Button>
          </Modal.Footer>
        </Modal>
      </ModalContext.Provider>
    </AuthContext.Provider>
  );
};

export default Layout;
